import { render } from "./PlaceholderComponent.vue?vue&type=template&id=1b20be24"
import script from "./PlaceholderComponent.vue?vue&type=script&lang=js"
export * from "./PlaceholderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__